import React, { useEffect, useState } from "react";
import { IStep, IAnswers } from "../../../steps";
import FormControlLabel from "../FormControlLabel";
import RadioGroup from "../RadioGroup";
import { Radio } from "@material-ui/core";
import StepInfoAssociation from "../StepInfoAssociation";
import { useSelector } from "react-redux";
import { getStepAnswers } from "../../../reducers/steps/selectors";

interface StepOptionProps {
  value?: string;
  step: IStep & { ansewers?: any[] };
  change: (answer: IAnswers) => () => void;
}

function StepOptions({ value, step, change }: StepOptionProps) {
  return (
    <RadioGroup value={value} name={step.step}>
      {step.answers.map((answer: any, index: number) => {
        const debugFeatures = step.ansewers?.[index]?.features;

        return (
          <React.Fragment key={answer.name}>
            <FormControlLabel
              onChange={change(answer)}
              value={answer.name}
              control={<Radio />}
              label={answer.content}
            />
            {process.env.REACT_APP_DEBUG && debugFeatures && (
              <div style={{ marginTop: "-20px", marginBottom: "20px" }}>
                {debugFeatures.map((f: any) => (
                  <p key={f.nameVerbose}>
                    {f.nameVerbose} {f.valueVerbose}
                  </p>
                ))}
              </div>
            )}
          </React.Fragment>
        );
      })}
    </RadioGroup>
  );
}

function CustomStep6({ step, onChange, value }: CustomStep6Props) {
  const stepsAnswers = useSelector(getStepAnswers);
  const [twin, setTwin] = useState(false);
  const [roof, setRoof] = useState(false);
  const [flat, setHouse] = useState(false);

  useEffect(() => {
    setTwin(!!stepsAnswers.find((s) => s.answer === "twinHouse"));
    setHouse(!!stepsAnswers.find((s) => s.answer === "flat"));
  }, [stepsAnswers]);

  const change = (answer: IAnswers) => () => {
    setRoof(answer.name === "roof" || answer.name === "freeSpace");
    onChange(answer);
  };

  return (
    <>
      <StepOptions value={value} step={step} change={change} />
      {roof && (twin || flat) && <StepInfoAssociation />}
    </>
  );
}

export interface CustomStep6Props {
  step: IStep & { ansewers?: any[] };
  value?: string;
  onChange: (answer: IAnswers) => void;
}

export default CustomStep6;
